{
  "mandatoryFields": {
    "part1": "Les champs précédés d'un",
    "part2": "sont obligatoires"
  },
  "confirm": {
    "leave": {
      "page": {
        "title": "Quitter la page ?",
        "message": {
          "unsavedData": "Des modifications ont été effectuées et ne seront pas sauvegardées. Souhaitez-vous quitter la page ?"
        }
      }
    },
    "okLabel": "Confirmer",
    "cancelLabel": "Annuler",
    "cancel": {
      "title": "Annuler les modifications ?",
      "message": "Des modifications ont été effectuées et ne seront pas sauvegardées. Annuler les modifications ?"
    }
  },
  "noData": "Aucune donnée"
}
